import React from 'react'

export default function PublicLayout({ children }) {
  return (
    <div className="">
      {children}
    </div>
  )
}
